<style>
.multiselect__content-wrapper {
  position: relative;
}

.character-option-icon {
  margin: 0 6px 0 0;
  height: 22px;
}

.character-label-icon {
  margin: 0 6px 0 0;
  height: 26px;
}

.map_holder {
  width: 100%;
  height: 450px;
}

.fa-minus-circle {
  color: #e74c3c;
  cursor: pointer;
}
.fa-plus-circle {
  color: #27c24c;
  cursor: pointer;
}

.redes {
  display: inline-block;
  width: calc(100% - 45px);
}
</style>
<template>
  <admin-layout>
    <template v-slot:breadcrumb>
      <ol class="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
        <li class="breadcrumb-item text-sm">
          <a class="opacity-5 text-white" href="javascript:;">Admin</a>
        </li>
        <li class="breadcrumb-item text-sm text-white" aria-current="page">
          Serviços
        </li>
      </ol>
    </template>

    <template v-slot:header>
      <h5 class="font-weight-bolder text-white mt-4 mb-0">Serviços</h5>
    </template>

    <template #content>
      <div class="row">
        <div class="col-12">
          <div class="card mb-4">
            <div class="card-header pb-0">
              <div class="row">
                <div class="col-8">
                  <button
                    class="btn btn-primary"
                    @click="
                      openModal();
                      mudarEnd('Brasil', 3);
                    "
                  >
                    Novo <i class="fas fa-plus"></i>
                  </button>
                </div>

                <div class="col-4">
                  <div class="input-group">
                    <span class="input-group-text">
                      <i
                        @click="search"
                        class="fas fa-search"
                        style="cursor: pointer"
                        aria-hidden="true"
                      ></i>
                    </span>
                    <input
                      v-model="filter"
                      @input="search"
                      type="text"
                      class="form-control"
                      placeholder="Pesquisar"
                    />
                    <button
                      v-if="filter"
                      class="input-group-text"
                      type="button"
                      @click="clearFilter"
                    >
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                </div>

                <div class="row mx-2">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="filterAtivo"
                      id="fcustomCheck1"
                      @change="filterServicosAtivos"
                    />
                    <label class="custom-control-label" for="customCheck1"
                      >Somente ativos</label
                    >
                  </div>
                </div>
              </div>
            </div>

            <div class="card-body px-0 pt-0 pb-2">
              <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >
                        Titulo
                      </th>

                      <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >
                        Subcategoria
                      </th>

                      <!--           <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >
                        Endereço
                      </th> -->

                      <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >
                        Lojista
                      </th>

                      <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >
                        Cupons
                      </th>

                      <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >
                        Ativo
                      </th>

                      <th
                        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >
                        Data de criação
                      </th>
                      <th class="text-secondary opacity-7"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(servico, index) in servicos.data" :key="index">
                      <!--       <td class="align-middle">
                        <a
                          href="javascript:;"
                          class="text-secondary font-weight-bold text-xs"
                          data-toggle="tooltip"
                          data-original-title="Edit"
                          @click.prevent="
                            edit(servico);
                            mudarEnd(
                              servico.endereco,
                              15,
                              servico.latitude,
                              servico.longitude
                            );
                          "
                        >
                          Editar </a
                        > --><!-- |
                        <a
                          href="javascript:;"
                          class="text-secondary font-weight-bold text-xs"
                          @click="deleteModal(servico)"
                        >
                          Remover
                        </a> -->
                      <!--   </td> -->

                      <td>
                        <div class="px-4 py-1">
                          <div class="justify-content-center">
                            <a
                              style="cursor: pointer"
                              @click.prevent="
                                edit(servico);
                                mudarEnd(
                                  servico.endereco,
                                  15,
                                  servico.latitude,
                                  servico.longitude
                                );
                              "
                            >
                              <h6 class="mb-0 text-sm">
                                {{ servico.titulo }}
                              </h6>
                            </a>
                            <!--        <p class="text-xs text-secondary mb-0">
                              john@creative-tim.com
                            </p> -->
                          </div>
                        </div>
                      </td>

                      <td>
                        <div class="px-4 py-1">
                          <div class="justify-content-center">
                            <h6 class="mb-0 text-sm">
                              {{ servico.subcategoria.descricao }}
                            </h6>
                            <!--        <p class="text-xs text-secondary mb-0">
                              john@creative-tim.com
                            </p> -->
                          </div>
                        </div>
                      </td>

                      <!--             <td>
                        <div class="px-4 py-1">
                          <div class="justify-content-center">
                            <h6 class="mb-0 text-sm">
                              {{ servico.endereco }}
                            </h6>

                          </div>
                        </div>
                      </td> -->

                      <td class="">
                        <Link
                          :href="
                            route('admin.servico.lojistas.index', {
                              uuid: servico.uuid,
                            })
                          "
                        >
                          <i
                            style="cursor: pointer"
                            class="fas fa-user-plus text-primary"
                          ></i>
                        </Link>
                      </td>

                      <td class="">
                        <Link
                          :href="
                            route('admin.servico.cupons.index', {
                              uuid: servico.uuid,
                            })
                          "
                        >
                          <i
                            style="cursor: pointer"
                            class="fas fa-ticket-alt text-primary"
                          ></i>
                        </Link>
                      </td>

                      <td v-if="servico.ativo" class="text-sm">
                        <span class="mx-2 badge badge-sm bg-gradient-success"
                          >Ativo</span
                        >
                      </td>

                      <td v-if="!servico.ativo" class="mx-3 text-sm">
                        <span class="mx-2 badge badge-sm bg-gradient-danger"
                          >Inativo</span
                        >
                      </td>

                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">{{
                          formatarData(servico.created_at)
                        }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card-footer">
              <pagination :links="servicos.links"></pagination>
            </div>
          </div>
        </div>
      </div>
    </template>
  </admin-layout>

  <!-- Modal -->
  <div
    class="modal fade"
    id="modalServico"
    tabindex="-1"
    aria-labelledby="modalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <form @submit.prevent="checkMode">
          <div class="modal-header">
            <h5 class="modal-title" id="modalLabel">{{ formTitle }}</h5>
            <span
              style="cursor: pointer"
              @click="closeModal"
              aria-label="Close"
              aria-hidden="true"
              >×</span
            >
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="example-text-input" class="form-control-label"
                    >Título</label
                  >
                  <input
                    v-model="form.titulo"
                    class="form-control"
                    type="text"
                    onfocus="focused(this)"
                    onfocusout="defocused(this)"
                    :class="{ 'is-invalid': form.errors.titulo }"
                  />
                </div>
                <div
                  class="invalid-feedback mb-3"
                  :class="{ 'd-block': form.errors.titulo }"
                >
                  {{ form.errors.titulo }}
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for="example-text-input" class="form-control-label"
                    >Contato</label
                  >
                  <input
                    v-model="form.contato"
                    class="form-control"
                    type="text"
                    onfocus="focused(this)"
                    onfocusout="defocused(this)"
                    :class="{ 'is-invalid': form.errors.contato }"
                  />
                </div>
                <div
                  class="invalid-feedback mb-3"
                  :class="{ 'd-block': form.errors.contato }"
                >
                  {{ form.errors.contato }}
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for="example-text-input" class="form-control-label"
                    >Categoria</label
                  >
                  <select
                    id="subcategoria_id"
                    v-model="form.categoria_id"
                    class="form-control"
                    :class="{ 'is-invalid': form.errors.categoria_id }"
                  >
                    <option
                      v-for="(cat, index) in categorias"
                      :key="index"
                      :value="cat.id"
                    >
                      {{ cat.descricao }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for="example-text-input" class="form-control-label"
                    >Subcategoria</label
                  >
                  <select
                    id="subcategoria_id"
                    v-model="form.subcategoria_id"
                    class="form-control"
                    :class="{ 'is-invalid': form.errors.subcategoria_id }"
                  >
                    <option
                      v-for="(cat, index) in filteredItems"
                      :key="index"
                      :value="cat.id"
                    >
                      {{ cat.descricao }}
                    </option>
                  </select>
                </div>
                <div
                  class="invalid-feedback mb-3"
                  :class="{ 'd-block': form.errors.subcategoria_id }"
                >
                  {{ form.errors.subcategoria_id }}
                </div>
              </div>

              <div v-if="editMode" class="col-md-12">
                <div class="form-group">
                  <label for="example-text-input" class="form-control-label"
                    >Ativo</label
                  >
                  <select id="ativo" class="form-control" v-model="form.ativo">
                    <option value="1">Sim</option>
                    <option value="0">Não</option>
                  </select>
                </div>
                <div
                  class="invalid-feedback mb-3"
                  :class="{ 'd-block': form.errors.valor }"
                >
                  {{ form.errors.valor }}
                </div>
              </div>

              <!-- teste corte de imagem -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <a
                      class="btn"
                      v-bind:class="{ disabled: checkbtn }"
                      @click="toggleShow2"
                      >Carregar Imagem</a
                    >

                    <my-upload
                      field="img"
                      @crop-success="cropSuccess"
                      @crop-upload-success="cropUploadSuccess"
                      @crop-upload-fail="cropUploadFail"
                      v-model="show"
                      :width="1280"
                      :height="720"
                      :url="urlBase"
                      :params="params"
                      :headers="headers"
                      :maxSize="5024"
                      :noCircle="true"
                      img-format="png"
                      langType="pt-br"
                    >
                    </my-upload>

                    <br />

                    <div
                      v-if="checkbtn"
                      class="invalid-feedback mb-3"
                      :class="{ 'd-block': checkbtn }"
                    >
                      Você chegou no limite de fotos enviadas
                    </div>

                    <div
                      class="invalid-feedback mb-3"
                      :class="{ 'd-block': form.errors.img }"
                    >
                      {{ form.errors.img }}
                    </div>

                    <ul class="image-list">
                      <li
                        class="list"
                        v-for="(item, index) in imgDataList"
                        :key="index"
                      >
                        <a
                          v-if="imgDataList"
                          class="btn btn-icon btn-2 btn-danger"
                          style="
                            padding: 1px 4px;
                            right: -20px;
                            top: -30px;
                            position: relative;
                          "
                          @click="removerImg(index, item)"
                        >
                          <i class="ni ni-fat-delete"></i>
                        </a>
                        <img
                          v-if="item"
                          :src="'/storage/img/' + setor + '/' + item"
                          width="150"
                          height="100"
                        />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <!--- teste corte de imagem --->

              <div class="col-md-12">
                <div class="form-group">
                  <label for="example-text-input" class="form-control-label"
                    >Tags</label
                  >

                  <multiselect
                    v-model="form.tags"
                    placeholder="Selecione as tags do serviço"
                    label="descricao"
                    :option-height="104"
                    :options="options"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    track-by="descricao"
                    :preselect-first="false"
                  >
                    <template v-slot:singlelabel="{ value }">
                      <div class="multiselect-single-label">
                        <img
                          class="character-label-icon"
                          :src="value.icone.link_img"
                        />
                        {{ value.descricao }}
                      </div>
                    </template>

                    <template v-slot:option="{ option }">
                      <img
                        class="character-option-icon"
                        :src="option.icone.link_img"
                      />
                      {{ option.descricao }}
                    </template>
                  </multiselect>
                </div>
                <div
                  class="invalid-feedback mb-3"
                  :class="{ 'd-block': form.errors.tags }"
                >
                  {{ form.errors.tags }}
                </div>
              </div>

              <div v-if="ready" class="col-md-12">
                <div class="map_holder">
                  <place-search
                    v-bind:ready="ready"
                    placeholder="Digite o endereço"
                    loading="Map is loading"
                    v-bind:gps_timeout="7000"
                    v-bind:fallbackProcedure="fallbackProcedure"
                    v-bind:zoom="zoom"
                    v-bind:geolocation="geolocation"
                    v-bind:address="address"
                    v-bind:manually="manually"
                    v-bind:verConsole="verConsole"
                    v-bind:query_mod="query_mod"
                    @changed="getMapData"
                  >
                  </place-search>
                </div>
              </div>
              <div
                class="invalid-feedback mb-3"
                :class="{ 'd-block': form.errors.endereco }"
              >
                {{ form.errors.endereco }}
              </div>
              <hr class="mt-3" />
              <div class="col-md-12">
                <label for="example-text-input" class="h5"
                  >Mídias Sociais</label
                >

                <div
                  class="form-group"
                  v-for="(input, k) in form.redes"
                  :key="k"
                >
                  <div class="row">
                    <div class="col-4">
                      <label for="example-text-input" class="form-control-label"
                        >Mídia Social</label
                      >
                      <select
                        v-model="input.rede_id"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors[`redes.${k}.rede_id`],
                        }"
                      >
                        <option
                          v-for="(rede, index) in redes"
                          :key="index"
                          :value="rede.id"
                        >
                          {{ rede.descricao }}
                        </option>
                      </select>
                      <div
                        class="invalid-feedback mb-3"
                        :class="{
                          'd-block': form.errors[`redes.${k}.rede_id`],
                        }"
                      >
                        {{ form.errors[`redes.${k}.rede_id`] }}
                      </div>
                    </div>
                    <div class="col-5">
                      <label for="example-text-input" class="form-control-label"
                        >Link</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        v-model="input.link"
                        :class="{
                          'is-invalid': form.errors[`redes.${k}.link`],
                        }"
                      />

                      <div
                        class="invalid-feedback mb-3"
                        :class="{
                          'd-block': form.errors[`redes.${k}.link`],
                        }"
                      >
                        {{ form.errors[`redes.${k}.link`] }}
                      </div>
                    </div>

                    <div class="col-3 mt-4 pt-3">
                      <span>
                        <i
                          class="fas fa-minus-circle"
                          @click="remove(k)"
                          v-show="k || (!k && form.redes.length > 1)"
                        ></i>
                        <i
                          class="mx-1 fas fa-plus-circle"
                          @click="add(k)"
                          v-show="k == form.redes.length - 1"
                        ></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for="example-text-input" class="form-control-label"
                    >Descrição</label
                  >
                  <textarea
                    v-model="form.descricao"
                    class="form-control"
                    onfocus="focused(this)"
                    onfocusout="defocused(this)"
                    :class="{ 'is-invalid': form.errors.descricao }"
                    rows="4"
                  >
                  </textarea>
                </div>
                <div
                  class="invalid-feedback mb-3"
                  :class="{ 'd-block': form.errors.descricao }"
                >
                  {{ form.errors.descricao }}
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">
              Fechar
            </button>
            <button type="submit" class="btn btn-success">
              {{ buttonTxt }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import Pagination from "@/Components/Pagination";
import { Link } from "@inertiajs/inertia-vue3";
import myUpload from "vue-image-crop-upload";
import moment from "moment";

export default {
  props: [
    "servicos",
    "subcategorias",
    "tags",
    "redes",
    "categorias",
    "setor",
    "prefeitura_url",
  ],
  components: {
    "my-upload": myUpload,
    AdminLayout,
    Pagination,
    Link,
    moment,
  },

  data() {
    return {
      modal: Object,

      show: false,
      verConsole: true,
      t_lat: "",
      t_lng: "",

      urlBase: "/admin/galeria/uploadimg/" + this.setor,
      arquivo_nome: "",
      params: {
        setor: this.setor,
      },
      headers: {
        smail: "*_~",
      },
      imgDataUrl: "",
      imgDataList: [],

      options: this.tags,

      filterAtivo: false,
      filter: "",
      editMode: false,

      contatoMask: "",

      form: this.$inertia.form({
        id: "",
        titulo: "",
        contato: "",
        img: "",
        descricao: "",
        categoria_id: "",
        subcategoria_id: "",
        tags: "",
        latitude: "",
        longitude: "",
        endereco: "",
        redes: [{}],
        ativo: "",
      }),

      ready: false, //Add ready:false to stop map from loading, and then when changed to true map will auto load
      fallbackProcedure: "address", //gps | geolocation | address | manually
      zoom: 10, //Default Zoom
      geolocation: {
        // If GPS and Find by address fails then, map will be positioned by a default geolocation
        lat: -23.5505,
        lng: -46.6333,
        zoom: 19,
      },
      address: {
        query: "Brazil", //If GPS fails, Find by address is triggered
        zoom: 19, //Default Zoom
        lat: -23.5505,
        lng: -46.6333,
      },
      manually: {
        address_description: "",
        city: "",
        country: "",
        lat: -22.9597,
        lng: -44.0411,
        state: "",
        zip_code: "",
        zoom: 13,
      },
      place: {},
      form_data: {},

      query_mod: "",
    };
  },
  computed: {
    formTitle() {
      return this.editMode === false ? "Adicionar Serviço" : "Editar Serviço";
    },
    buttonTxt() {
      return this.editMode === false ? "Salvar" : "Editar";
    },
    checkMode() {
      return this.editMode === false ? this.create : this.update;
    },

    filteredItems: function () {
      return this.subcategorias.filter(function (el) {
        return el.categoria_id === this.form.categoria_id;
      }, this);
    },

    checkbtn() {
      if (this.imgDataList.length >= 6) {
        return true;
      } else {
        return false;
      }
    },
  },

  methods: {
    formatarData(data) {
      return moment(data).format("DD/MM/YYYY HH:mm:ss");
    },

    mudarMap($lat, $lng, $zoom = 17, $end = "") {
      this.query_mod = $end;
      this.geolocation = {
        lat: $lat,
        lng: $lng,
        zoom: $zoom,
      };
      this.fallbackProcedure = "geolocation";
      this.ready = true;
      this.query_mod = $end;
      if (this.verConsole) {
        console.log("Lat: " + $lat);
        console.log("Lng: " + $lng);
      }
    },

    mudarEnd(end, zoom = 15, lat = 0, lng = 0) {
      (this.address = {
        query: end,
        zoom: zoom,
        lat: lat,
        lng: lng,
      }),
        (this.fallbackProcedure = "address");

      if (this.verConsole) {
        console.log("Endereço: " + this.endereco);
      }

      setTimeout(() => (this.ready = false), 500);
      setTimeout(() => (this.ready = true), 500);
    },

    toggleShow2() {
      this.show = !this.show;
    },

    removerImg(index, item) {
      this.imgDataList.splice(index, 1);
      console.log(this.imgDataList);
      axios.post("/admin/galeria/removerimg", { file: item });
    },

    cropSuccess(imgDataUrl, field) {
      console.log("-------- crop success --------");
      this.imgDataUrl = imgDataUrl;
    },

    cropUploadSuccess(jsonData, field) {
      this.imgDataList.push(this.prefeitura_url + "/" + jsonData.file);
      console.log("-------- upload success --------");
      console.log(jsonData);
      console.log("Arquivo: " + jsonData.file);
      console.log("Arquivo List: " + this.imgDataList);
      console.log("field: " + field);
      console.log("----------------- FORMULÁRIO -------------------");
      console.log(this.form);
    },

    cropUploadFail(status, field) {
      console.log("-------- upload fail --------");
      console.log(status);
      console.log("field: " + field);
    },

    openModal() {
      this.imgDataList = [];
      this.editMode = false;

      this.form.clearErrors();
      this.modal.show();
      this.form.reset();
    },

    closeModal() {
      this.modal.hide();
      this.form.clearErrors();
      this.editMode = false;
    },

    create() {
      this.form.img = this.imgDataList;
      this.form.post(this.route("admin.servicos.store"), {
        preserveScroll: true,
        onSuccess: () => {
          this.closeModal();
          this.form.reset();
        },
      });
    },

    edit(servico) {
      this.form.reset();
      this.openModal();
      this.editMode = true;

      this.form = Object.assign(this.form, servico);

      this.address.query = servico.endereco;

      console.log("Query: " + this.address);

      this.imgDataList = Object.values(servico.img);

      let redes = servico.redes.map((item) => {
        return item.pivot;
      });
      this.form.categoria_id = servico.subcategoria.categoria_id;

      this.form.redes = redes;

      if (this.form.redes.length == 0) {
        this.form.redes = [{}];
      }
    },

    update() {
      this.form.img = this.imgDataList;
      this.form.patch(
        this.route("admin.servicos.update", this.form.id, this.form),
        {
          preserveScroll: true,
          onSuccess: () => {
            this.closeModal();
            this.form.reset();
          },
        }
      );
    },

    search() {
      if (this.filter === "") {
        this.$inertia.visit(window.location.pathname);
      } else {
        this.$inertia.get(
          route("admin.servicos.index"),
          {
            filter: this.filter,
            ativo: this.filterAtivo,
          },
          { preserveState: true }
        );
      }
    },

    clearFilter() {
      this.filter = "";
      this.search();
    },

    filterServicosAtivos() {
      this.$inertia.get(
        route("admin.servicos.index"),
        {
          filter: this.filter,
          ativo: this.filterAtivo,
        },
        { preserveState: true }
      );
    },

    deleteModal(servico) {
      Swal.fire({
        title: "Tem certeza que deseja deletar?",
        text: "Você não será capaz de reverter essa ação!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, deletar!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.form.delete(this.route("admin.servicos.destroy", servico), {
            preserveScroll: true,
            onSuccess: () => {
              Swal.fire("Deletado!", "Serviço deletado", "success");
            },
          });
        }
      });
    },

    getMapData(place) {
      this.place = place;
      // console.log(place);
      this.form.latitude = place.lat;
      this.form.longitude = place.lng;
      this.form.endereco = place.address_description;
    },
    triggerReady() {
      this.fallbackProcedure = "manually";
      this.ready = true;
    },

    add(k) {
      this.form.redes.push({
        rede_id: "",
        link: "",
      });
    },

    remove(k) {
      this.form.redes.splice(k, 1);
    },

    updateMask(value) {
      const phoneNumber = PhoneNumber.parsePhoneNumberFromString(value);
      if (phoneNumber.isValid()) {
        const phoneType = PhoneNumber.getPhoneType(phoneNumber);
        const numberLength = phoneNumber.nationalNumber.toString().length;
        switch (phoneType) {
          case "FIXED_LINE_OR_MOBILE":
            if (numberLength === 10) {
              this.mask = "(##) #####-####";
            } else {
              this.mask = "(##) ####-####";
            }
            break;
          case "TOLL_FREE":
            this.mask = "0800 ######";
            break;
          default:
            this.mask = "";
            break;
        }
      }
    },
  },
  created() {},
  mounted() {
    this.modal = new bootstrap.Modal(
      document.getElementById("modalServico"),
      {}
    );
  },
  watch: {
    query_mod: function (val) {
      console.log("query_mod: " + val);
    },

    address: {
      handler: function (val) {
        // console.log("watch: "+val);
        this.form.endereco = val;
      },
      deep: true,
    },
  },
};
</script>

<style>
li.list {
  float: left;
  padding: 5px;
}
ul.image-list {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
</style>

